import {
  deviceDataFormatted,
  sharedDeviceDataFormatted,
  getSingleDevFormatted,
} from '@/js/utils';
import Vue from 'vue';

const SET_DEVICE_DATA = (state, deviceInfo) => {
  state.deviceData = deviceDataFormatted(deviceInfo);
};

const SET_SHARED_DEVICE_LIST = (state, deviceInfo) => {
  state.sharedDeviceData = sharedDeviceDataFormatted(deviceInfo);
};

const SET_PROMISE = (state, promise) => {
  state.promise = promise;
};

const SET_SHARED_DEVICE_PROMISE = (state, promise) => {
  state.sharedDevicePromise = promise;
};

const UPDATE_DEVICE_DATA = (state, dataList) => {
  if (Array.isArray(dataList)) {
    dataList.forEach((dev) => {
      if (dev) {
        const deviceIndex = state.deviceData.findIndex(
          (d) => d.dev_id === dev.dev_id
        );
        if (deviceIndex !== -1) {
          Vue.set(state.deviceData, deviceIndex, getSingleDevFormatted(dev));
        }
      }
    });
  }
};

const SET_SHARE_DEVICE = (state, { dev_id, body }) => {
  if (!dev_id || !body) {
    return;
  }
  const deviceIndex = state.shareDevice.findIndex(
    (device) => device.dev_id === dev_id
  );

  if (deviceIndex === -1) {
    state.shareDevice.push({
      dev_id,
      users: Array.isArray(body) ? body : [body],
    });
  } else {
    if (Array.isArray(body)) {
      Vue.set(state.shareDevice, deviceIndex, { dev_id, users: body });
    } else {
      const userIndex = state.shareDevice[deviceIndex].users.findIndex(
        (u) => u.receiver_id === body.receiver_id
      );
      if (userIndex === -1) state.shareDevice[deviceIndex].users.push(body);
    }
  }
};

const SET_SHARE_USER_DEVICE = (state, { dev_id, body }) => {
  const deviceIndex = state.shareDevice.findIndex(
    (device) => device.dev_id === dev_id
  );
  if (deviceIndex === -1) {
    state.shareDevice.push({
      dev_id,
      users: Array.isArray(body) ? body : [body],
    });
  } else {
    if (Array.isArray(body)) {
      Vue.set(state.shareDevice, deviceIndex, { dev_id, users: body });
    } else {
      const userIndex = state.shareDevice[deviceIndex].users.findIndex(
        (u) => u.receiver_id === body.receiver_id
      );
      if (userIndex === -1) state.shareDevice[deviceIndex].users.push(body);
    }
  }
};

const REMOVE_SHARE_USER_DEVICE = (state, { dev_id, share_id }) => {
  const shareUser = state.shareDevice.find(
    (device) => device.dev_id === dev_id
  );
  if (shareUser) {
    const user_index = shareUser.users.findIndex(
      (users) => users.share_id === share_id
    );
    if (user_index !== -1) shareUser.users.splice(user_index, 1);
  }
};

const REMOVE_SHARE_DEVICE = (state, { dev_id }) => {
  if (!Array.isArray(state.sharedDeviceData)) {
    return;
  }
  const devIndex = state.sharedDeviceData.findIndex(
    (device) => device.dev_id === dev_id
  );
  if (devIndex !== -1) state.sharedDeviceData.splice(devIndex, 1);
};

export default {
  SET_DEVICE_DATA,
  SET_PROMISE,
  UPDATE_DEVICE_DATA,
  SET_SHARE_DEVICE,
  SET_SHARE_USER_DEVICE,
  REMOVE_SHARE_USER_DEVICE,
  SET_SHARED_DEVICE_LIST,
  SET_SHARED_DEVICE_PROMISE,
  REMOVE_SHARE_DEVICE,
};
